import React from 'react';
import { useHistory } from 'react-router-dom';
import './ResolutionConfirmation.css';

/**
 * Confirmation page component for bulk resolution submission.
 *
 * Displays success message after submitting resolution request.
 * Provides navigation options to return to dashboard or submit another request.
 *
 * @param {Object} props Component props
 * @param {number} props.itemCount Number of items submitted for resolution
 */
const ResolutionConfirmation = ({ itemCount }) => {
	const history = useHistory();

	/**
	 * Handle submit another request.
	 */
	const handleSubmitAnother = () => {
		window.location.reload();
	};

	return (
		<div className="resolution-confirmation-page">
			<div className="confirmation-card">
				<div className="confirmation-icon">
					<svg
						width="80"
						height="80"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<circle cx="12" cy="12" r="10" />
						<path d="M9 12l2 2 4-4" />
					</svg>
				</div>

				<h1>Resolution Request Submitted</h1>

				{/* <p className="confirmation-message">
					Your request to resolve <strong>{itemCount}</strong> item
					{itemCount !== 1 ? 's' : ''} has been successfully submitted to our
					team.
				</p> */}

				<p className="confirmation-subtext">
					Our admins will review your request and contact you shortly at the
					email address associated with your account.
				</p>

				<div className="confirmation-actions">
					<button
						className="btn btn-primary"
						onClick={() => history.push('/dashboard')}
					>
						Go to Dashboard
					</button>
					<button className="btn btn-secondary" onClick={handleSubmitAnother}>
						Submit Another Request
					</button>
				</div>
			</div>
		</div>
	);
};

export default ResolutionConfirmation;
